'use client';

import { useTranslations } from '@/hooks/useTranslations';
import { TClientData } from '@/types/client';
import { Title } from '@/components/title';
import { TableWrapper } from '@/components/table/table-wrapper';
import { useClientContext } from '@/contexts/client-context';
import { defineClientColumns } from '@/components/table/columns/client/client-columns';
import { useMemo } from 'react';
import { Users } from 'lucide-react';

export const ClientsDashboard = ({ data }: { data: TClientData[] }) => {
  const { dispatch } = useClientContext();

  const t = useTranslations('ClientsDashboard');
  const translation = useTranslations('ClientsTable');

  const columns = useMemo(
    () => defineClientColumns(translation),
    [translation]
  );

  return (
    <div className="p-3 md:p-10">
      <Title translation={t} />

      <TableWrapper<TClientData>
        columns={columns}
        data={data}
        filters={true}
        pagination={true}
        isFull={true}
        count={20}
        translation={translation}
        searchLabel="name"
        cta={{
          label: t('createClient'),
          onClick: () => dispatch({ type: 'OPEN_CREATE_CLIENT_POPUP' }),
        }}
        emptyState={{
          title: useTranslations('Empty')('clients.title'),
          description: useTranslations('Empty')('clients.description'),
          icon: <Users className="h-12 w-12" />,
          hideLearnMore: true,
        }}
      />
    </div>
  );
};
